import { createCustomEvent } from '../../shared/helpers';

export default class extends Controller {
  static targets = ['timeField', 'timeToggle', 'repeatToggle', 'repeatFieldsContainer', 'startDateField'];

  connect() {
    this.toggleTimeFields();
    this.toggleRepeatFields();
  }

  toggleTimeFields() {
    this.timeFieldTargets.forEach(t => t.style.display = this.timeToggleTarget.checked ? 'none' : 'block');
  }

  toggleRepeatFields() {
    this.repeatFieldsContainerTarget.style.display = this.repeatToggleTarget.checked ? 'block' : 'none';
  }

  updateDateForRepeatFields(event) {
    const date = event.target.value ? moment(event.target.value).format('YYYY-MM-DD') : '';
    this.startDateFieldTargets.forEach(t => {
      t.value = date
      t.dispatchEvent(createCustomEvent('startDateChange'), t, {});
    });
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/events/campaign-brief-event-form-controller.js